import React, {
  useEffect,
} from 'react';
import clsx from 'clsx';
import InputText from 'components/common/InputText';
import {
  formatSignatureTimestamp,
  isEmptyString,
} from 'utils/helper';
import {
  FieldComponentProps,
} from 'components/anvilFormFillable/fields/types';

export default function SignatureTimestamp({
  field,
  value,
  onChange,
}: FieldComponentProps) {
  useEffect(() => {
    if (isEmptyString(value?.value)) {
      onChange({ ...value, value: formatSignatureTimestamp() });
    }
    // Preview only; authoritative value is set server-side at PDF generation.
  }, [value?.value]);

  return (
    <InputText
      key={field.id}
      id={field.id ?? undefined}
      value={typeof value.value === 'string' ? value.value : ''}
      disabled
      className={clsx('w-full bg-[#e9edf4]')}
    />
  );
}
